import View from 'mixins/view';
import BannersView from 'ui/matchCalendar/event/main-day-banner-view';

const elements = {
  score: '.c-calendar__score',
};

export default class extends View {
  constructor(model) {
    super(model);
    this.setRootEl($('<div></div>'));
  }
  hide() {
    this.rootEl.addClass('fn-hidden');
  }
  setScore() {
    const home = this.model.get('homeScore');
    const away = this.model.get('awayScore');

    if (!isNaN(parseInt(home)) && !isNaN(parseInt(away))) {
      this.rootEl.find(elements.score)
        .html(`
          <h5 class="score-huge rmpl-flex-container rmpl-flex-aligned">${home}<span>:</span>${away}</h5>
        `);
    }
  }
  render() {
    const model = this.model;
    this.rootEl
      .removeClass('fn-hidden')
      .addClass('background-color_lightenesgrey js-SlidingBox-Box ui-SlidingBox')
      .html(`
        <div class="c-calendar-main-dayly_match_following border_top-color_lightergrey">
          <h6 class="text-color_appgrey shift-margin_3-top box-vertical_align_middle">
              <img src="${model.get('icon')}" class="c-calendar-ballicon shift-margin_2-horizontal box-inline" alt="Match Icon">
              <span class="box-inline">${model.get('competition')}</span>
          </h6>
          <div class="mw-wrapper rmpl-flex-container box-full_width rmpl-flex-nowrap">

              <div class="match-container match-container-others rmpl-flex-item">
                <div class="rmpl-flex-nowrap rmpl-flex-container rmpl-flex-aligned">
                  <div class="mc-left rmpl-flex-item">
                    <div class="mc-item-container rmpl-flex-container rmpl-flex-aligned rmpl-flex-end rmpl-flex-nowrap">
                      <div class="mc-item-cell mc-item-mobile-disabled">
                        <h4 class="cf">${model.get('homeTeam')}</h4>
                      </div>
                      <div class="mc-item-cell">
                        <img src="${model.get('homeLogo')}" class="element-image" alt="Club Flag">
                      </div>
                      <div class="mc-item-cell mc-item-mobile-enabled">
                        <h4 class="cf">${model.get('homeTeam')}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="mc-score c-calendar__score rmpl-flex-item-auto">
                    <h5 class="score-small rmpl-flex-container rmpl-flex-aligned">vs</h5>
                  </div>
                  <div class="mc-right rmpl-flex-item">
                    <div class="mc-item-container rmpl-flex-container rmpl-flex-aligned rmpl-flex-start rmpl-flex-nowrap">
                      <div class="mc-item-cell">
                        <img src="${model.get('awayLogo')}" class="element-image" alt="Club Flag">
                      </div>
                      <div class="mc-item-cell mc-item-mobile-disabled">
                        <h4 class="cf">${model.get('awayTeam')}</h4>
                      </div>
                      <div class="mc-item-cell mc-item-mobile-enabled">
                        <h4 class="cf">${model.get('awayTeam')}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          </div>
        </div>
      `);

      if (model.get('banner')) {
        const banner = new BannersView(model);
        banner.createOtherBanner();
        banner.render();
        this.rootEl.append(banner.getRootEl());
      }

      this.setScore();
  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/event/other-day-view.js